const quote = {};

export default quote;
